// extracted by mini-css-extract-plugin
module.exports = {"page-content":"ProductContent_page-content__Tsg5c"};